import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HomePage } from "./components/HomePage/HomePage";
import { NavBar } from "./components/Navbar/Navbar";
import { PersonalProjects } from "./components/Pages/PersonalProjects";
import { TeamProjects } from "./components/Pages/TeamProjects";
import "./App.css";
import './components/Navbar/Navbar.css'
import "./components/HomePage/ProjectCard/ProjectCard.css";
import { Footer } from "./components/Footer/Footer";
import { ErrorPage } from "./components/Pages/Error";
import { useEffect, useState } from "react";

function App() {
  const [theme, setTheme] = useState<boolean>(true);
  useEffect(() => {
    if (localStorage.getItem("theme") === "sun") {
      document.body.classList.add("bg-gray-800");
      document.body.classList.add("dark");
      setTheme(true);
    } else if (localStorage.getItem("theme") === "moon") {
      document.body.classList.remove("bg-gray-800");
      document.body.classList.remove("dark");
      setTheme(false);
    } else if (theme) {
      document.body.classList.add("bg-gray-800");
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("bg-gray-800");
      document.body.classList.remove("dark");
    }
  }, [theme]);
  return (
    <>
      <BrowserRouter>
        <NavBar setTheme={setTheme} theme={theme} />
        <Routes>
          <Route path={"/"} element={<HomePage theme={theme} />} />
          <Route path={"/home"} element={<HomePage theme={theme} />} />
          <Route path={"/projects"} element={<PersonalProjects />} />
          <Route path={"/projects/:id"} element={<PersonalProjects />} />
          <Route path={"/team-projects"} element={<TeamProjects />} />
          <Route path={"/team-projects/:id"} element={<TeamProjects />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
